"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactModal = require("react-modal");

var _reactModal2 = _interopRequireDefault(_reactModal);

var _Box = require("../Box");

var _Box2 = _interopRequireDefault(_Box);

var _Button = require("../Button");

var _Button2 = _interopRequireDefault(_Button);

var _Flex = require("../Flex");

var _Flex2 = _interopRequireDefault(_Flex);

var _Text = require("../Text");

var _Text2 = _interopRequireDefault(_Text);

var _IconSvg = require("../IconSvg");

var _IconSvg2 = _interopRequireDefault(_IconSvg);

var _Image = require("../Image");

var _Image2 = _interopRequireDefault(_Image);

var _Input = require("../Input");

var _Input2 = _interopRequireDefault(_Input);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Checkbox = (0, _styledComponents2.default)(_Input2.default).withConfig({
  displayName: "AddToOrderModal__Checkbox",
  componentId: "n9z4pv-0"
})(["width:20px;"]);

const customStyle = {
  overlay: {
    backgroundColor: "rgba(33, 37, 48, 0.8)",
    zIndex: 2
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    borderRadius: 4,
    padding: 0
  }
};

const AddToOrderModal = ({
  isOpen,
  onClose,
  onAddToCart,
  imageUrl,
  title,
  description,
  price,
  removeOptions
}) => {
  const [quantity, setQuantity] = (0, _react.useState)(1);

  const onClickMinus = () => {
    if (quantity === 0) {
      return;
    }

    setQuantity(quantity - 1);
  };

  const onClickPlus = () => {
    setQuantity(quantity + 1);
  };

  const cleanData = () => {
    setQuantity(1);
  };

  const onClick = () => {
    cleanData();
    onClose();
    onAddToCart(quantity);
  };

  return _react2.default.createElement(
    _reactModal2.default,
    {
      isOpen: isOpen,
      onRequestClose: () => {
        cleanData();
        onClose();
      },
      style: customStyle
    },
    _react2.default.createElement(
      _Box2.default,
      {
        width: 512,
        style: {
          overflow: "scroll",
          height: "calc(100vh - 40px)",
          position: "relative"
        }
      },
      _react2.default.createElement(
        _Box2.default,
        {
          style: {
            position: "absolute",
            cursor: "pointer",
            top: 20,
            left: 20
          },
          onClick: onClose
        },
        _react2.default.createElement(_IconSvg2.default, { name: "close", color: "orange" })
      ),
      _react2.default.createElement(
        _Box2.default,
        null,
        _react2.default.createElement(_Image2.default, { height: 288, src: imageUrl })
      ),
      _react2.default.createElement(
        _Box2.default,
        { textAlign: "center", p: 2 },
        _react2.default.createElement(
          _Box2.default,
          { mt: 1, mb: 3 },
          _react2.default.createElement(
            _Text2.default,
            null,
            title
          )
        ),
        _react2.default.createElement(
          _Box2.default,
          { mb: 3 },
          _react2.default.createElement(
            _Text2.default,
            { color: "palette.ink.600" },
            description
          )
        )
      ),
      _react2.default.createElement(
        _Flex2.default,
        { justifyContent: "flex-end", p: 3 },
        _react2.default.createElement(
          _Text2.default,
          { fontSize: 3, fontWeight: 500, mr: 2 },
          "Quatity"
        ),
        _react2.default.createElement(
          _Flex2.default,
          null,
          _react2.default.createElement(_IconSvg2.default, { name: "plus", color: "orange", onClick: onClickPlus }),
          _react2.default.createElement(
            _Text2.default,
            { mx: 2 },
            quantity
          ),
          _react2.default.createElement(_IconSvg2.default, {
            disabled: quantity === 0,
            name: "minus",
            color: "orange",
            onClick: onClickMinus
          })
        )
      ),
      _react2.default.createElement(
        _Box2.default,
        { p: 3 },
        _react2.default.createElement(
          _Flex2.default,
          { alignItems: "center", justifyContent: "space-between" },
          _react2.default.createElement(
            _Text2.default,
            { fontSize: 2, fontWeight: 500 },
            "Remove"
          ),
          _react2.default.createElement(
            _Text2.default,
            null,
            "Optional"
          )
        ),
        _react2.default.createElement(
          _Box2.default,
          null,
          _react2.default.createElement(
            _Text2.default,
            { fontSize: 0, color: "palette.ink.600" },
            "Choose as many as you like"
          )
        ),
        removeOptions.map(r => {
          return _react2.default.createElement(
            _Flex2.default,
            { key: r, alignItems: "center" },
            _react2.default.createElement(
              _Box2.default,
              { mr: 2 },
              _react2.default.createElement(Checkbox, { type: "checkbox", value: false })
            ),
            _react2.default.createElement(
              _Text2.default,
              { fontSize: 2 },
              r
            )
          );
        })
      ),
      _react2.default.createElement(
        _Flex2.default,
        { justifyContent: "center", mb: 3 },
        _react2.default.createElement(
          _Button2.default,
          { width: "400px", onClick: onClick },
          "Add to Cart $",
          price * quantity
        )
      )
    )
  );
};

AddToOrderModal.propTypes = {
  isOpen: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  title: _propTypes2.default.string,
  description: _propTypes2.default.string,
  imageUrl: _propTypes2.default.string,
  price: _propTypes2.default.price,
  removeOptions: _propTypes2.default.array,
  onAddToCart: _propTypes2.default.func
};

AddToOrderModal.defaultProps = {
  title: "Pork Banh Mi",
  description: `Roasted black pepper-caramel pork shoulder with fried shallot mayo, pickled veggies, cilantro, cucumber, jalapeños, and maggi seasoning on a 8" baguette`,
  imageUrl: "https://popmenucloud.com/cdn-cgi/image/width=1200,height=1200,fit=scale-down,format=auto,quality=60/vdegtjyh/e7424958-f38a-4b9a-9876-b038a85e77e5.jpg",
  price: "11",
  removeOptions: ["No Jalapenos", "No Cilantro", "No Shallot Mayo", "No Pickled Veggies", "No Cucumber"]
};

exports.default = AddToOrderModal;